import React, { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Button.module.scss';

type ButtonProps = React.PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement>
> & {
  extraStyle?: string;
};

export default function Button({
  children,
  extraStyle,
  onClick,
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      className={classNames(styles.buttonClick, extraStyle)}
      onClick={onClick}
      type="submit"
      {...props}
    >
      {children}
    </button>
  );
}
